"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetSensorChartData = void 0;
const react_1 = require("react");
const SECONDS_TO_MS = 1000;
const useGetSensorChartData = (historicalData, key, translate, weekdayKeys = [
    'days.sun',
    'days.mon',
    'days.tue',
    'days.wed',
    'days.thu',
    'days.fri',
    'days.sat',
], daysToShow = 7) => (0, react_1.useMemo)(() => {
    const weekdayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    // Build map: date string -> value for that date
    const dateValueMap = new Map();
    if (historicalData) {
        for (const entry of historicalData) {
            if (!entry.values || !entry.values[key])
                continue;
            const value = entry.values[key];
            const date = new Date(entry.timestamp * SECONDS_TO_MS);
            const dateKey = date.toDateString(); // Use full date as key
            dateValueMap.set(dateKey, Math.round(typeof value === 'string' ? parseFloat(value) : Number(value)));
        }
    }
    // Generate the last N days chronologically, including today
    const data = [];
    for (let i = daysToShow - 1; i >= 0; i--) {
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() - i);
        const dateKey = targetDate.toDateString();
        const weekdayIndex = targetDate.getDay();
        data.push({
            label: weekdayNames[weekdayIndex],
            value: dateValueMap.has(dateKey) ? dateValueMap.get(dateKey) : null,
        });
    }
    return { data };
}, [historicalData, key, translate, weekdayKeys, daysToShow]);
exports.useGetSensorChartData = useGetSensorChartData;
